import { FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Orion Academy. All Rights Reserved.</p>

      <a
        href="https://instagram.com/orionacademy16"
        target="_blank"
        rel="noreferrer"
        className="insta"
      >
        <FaInstagram className="instaIcon" />
        <span>@orionacademy16</span>
      </a>
    </footer>
  );
}

export default Footer;